import http from "./http-common";
import { MARKET } from "./market";

const MARKET_CONFIG_STORAGE_KEY = "DST_MARKET_CONFIG";

/**
 * Fetches market config from the API (e.g. india.json, saudi.json by market).
 * Does not persist to localStorage; use saveMarketConfigToStorage after this.
 * @param {string} [market] - REACT_APP_MARKET (e.g. INDIA, SAUDI, SPAIN, EGYPT, BAHRAIN, EASTEUROPE). If omitted, uses MARKET from core/market.
 * @returns {Promise<Object|null>} The config object or null on failure.
 */
export function fetchMarketConfig(market) {
  const m = market != null ? market : MARKET;
  const query = m ? "?market=" + encodeURIComponent(m) : "";
  return http
    .get("/config" + query)
    .then((res) => (res && res.data ? res.data : null))
    .catch(() => null);
}

/**
 * Saves market config to localStorage.
 * @param {Object} config - The config object to store.
 */
export function saveMarketConfigToStorage(config) {
  if (!config) return;
  try {
    localStorage.setItem(MARKET_CONFIG_STORAGE_KEY, JSON.stringify(config));
  } catch (e) {
    if (process.env.NODE_ENV === "development") console.error("marketConfig save to localStorage failed", e);
  }
}

/**
 * Loads market config from localStorage.
 * @returns {Object|null} The parsed config or null.
 */
export function getMarketConfigFromStorage() {
  try {
    const raw = localStorage.getItem(MARKET_CONFIG_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    if (process.env.NODE_ENV === "development") console.error("marketConfig load from localStorage failed", e);
    return null;
  }
}

/**
 * Removes market config from localStorage (e.g. on logout).
 */
export function clearMarketConfigFromStorage() {
  try {
    localStorage.removeItem(MARKET_CONFIG_STORAGE_KEY);
  } catch (e) {
    if (process.env.NODE_ENV === "development") console.error("marketConfig clear from localStorage failed", e);
  }
}
